import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { getQuotationReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";

const QuotationReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/quotationreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights("/quotationreportform", PRINT_ACCESS);

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterSector = params?.filterSector;
  const filterType = params?.filterType;
  const filterCreatedBy = params?.filterCreatedBy;

  const loading = useAppSelector((state) => state.reports.loading);
  const QuotationListForReport = useAppSelector(
    (state) => state.reports.QuotationListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        filterFromDate: filterFromDate !== "0" ? filterFromDate : "",
        filterToDate: filterToDate !== "0" ? filterToDate : "",
        filterSector: filterSector !== "0" ? filterSector : 0,
        filterType: filterType !== "0" ? filterType : "",
        filterCreatedBy: filterCreatedBy !== "0" ? filterCreatedBy : 0,
      };
      dispatch(getQuotationReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "QuotationReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "quotationreport.xlsx");
  };

  const handleEdit = (item: any) => {
    navigate("/quotation/package/edit", {
      state: {
        QuotationID: item?.ID,
        SectorID: item?.SectorID,
      },
    });
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Quotation Report{" "}
          <span style={{ fontSize: 15 }}>
            {QuotationListForReport &&
              QuotationListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            QuotationListForReport &&
            QuotationListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            QuotationListForReport &&
            QuotationListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {QuotationListForReport && QuotationListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th style={{ background: "black", color: "white" }}>No</th>
                <th style={{ background: "black", color: "white" }}>Date</th>
                <th style={{ background: "black", color: "white" }}>
                  Quote No
                </th>
                <th style={{ background: "black", color: "white" }}>Name</th>
                <th style={{ background: "black", color: "white" }}>
                  Mobile No
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Tour Date
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Created By
                </th>
              </tr>
            </thead>
            <tbody>
              {QuotationListForReport &&
                QuotationListForReport.length > 0 &&
                QuotationListForReport?.map((quote: any, index: number) => (
                  <tr>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {quote?.CreatedOn
                        ? moment(quote?.CreatedOn, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </td>
                    <td
                      className="text-center hoverableName"
                      onClick={() => {
                        handleEdit(quote);
                      }}
                    >
                      {quote?.QuotationNo || ""}
                    </td>
                    <td>{quote?.FirstName + " " + quote?.LastName}</td>
                    <td className="text-center">{quote?.MobileNo || ""}</td>
                    <td>
                      {quote?.StartDate
                        ? moment(quote?.StartDate, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""}{" "}
                      -{" "}
                      {quote?.EndDate
                        ? moment(quote?.EndDate, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </td>
                    <td>{quote?.CreatedByName || ""}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default QuotationReportView;
